module.exports = __webpack_public_path__ + "img/gift.3cf1fa43.png";